import { Modal } from "react-bootstrap";

export function KYCModal({ styleCss, ...props }) {
    const { onHide } = props;
    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            contentClassName={styleCss + `-color`}
            centered
        >
            <Modal.Body className={"p-0"}>
                <div className="card card-user shadow-lg">
                    <div className="card-body p-4">
                        <h4 className="card-title text-sm text-left">KYC Policy of OG Labs N.V.</h4>
                        <p><strong>Last updated: June 2023</strong></p>

                        <p>When a user makes an aggregate lifetime total of deposits exceeding EUR 2000 or requests a withdrawal of any amount inside the degencoinflip.com Platform, then it is compulsory for them to perform a full KYC process.</p>
                        <p>During this process, the user will have to input some basic details about themselves and then upload:</p>
                        <ul>
                            <li>A copy of Government Issued Photo ID (in some cases front and back depending on the doc)</li>
                            <li>A selfie of themselves holding the ID doc</li>
                            <li>A bank statement/Utility Bill</li>
                        </ul>
                        <p>Once uploaded, the user will get a “Temporarily Approved” Status and the documents will now be on our side, and the “KYC Team” will have 24hrs to go over them and email the user about the outcome:</p>
                        <ul>
                            <li>Approval</li>
                            <li>Rejection</li>
                            <li>More information needed – No change in Status</li>
                        </ul>
                        <p>When the user is on “Temporarily Approved” Status then:</p>
                        <ul>
                            <li>They can use the platform normally </li>
                            <li>They cannot deposit more than EUR 500 in aggregate total</li>
                            <li>They cannot complete any withdrawal.</li>
                        </ul>

                        <h6>Guideline for the “KYC Process”</h6>
                        <ul>
                            <li>Proof of ID</li>
                            <li>Signature Is there</li>
                            <li>Country is not a Restricted Country: United States of America and its territories, France and its territories, Netherlands and its territories and countries that form the Kingdom of Netherlands including Bonaire, Sint Eustatius, Saba, Aruba, Curacao and Sint Maarten, Australia and its territories, Austria, Germany, United Kingdom of Great Britain, Northern Ireland, Spain. </li>
                            <li>Full Name matches client’s name</li>
                            <li>Document does not expire in the next 3 months</li>
                            <li>Owner is over 18 years of age</li>
                            <li>Proof of Residence</li>
                            <li>Bank Statement or Utility Bill</li>
                            <li>Country is not a Restricted Country: United States of America and its territories, France and its territories, Netherlands and its territories and countries that form the Kingdom of Netherlands including Bonaire, Sint Eustatius, Saba, Aruba, Curacao, and Sint Maarten, Australia and its territories, Austria, United Kingdom of Great Britain, Northern Ireland, Germany, Spain, and Cyprus. </li>
                            <li>Full Name matches client’s name and is same as in proof of ID.</li>
                            <li>Date of Issue: In the last 3 months</li>
                            <li>Selfie with ID</li>
                            <li>Holder is the same as in the ID document above</li>
                            <li>ID document is the same as in “1”. Make sure photo/ID number is the same</li>
                        </ul>

                        <h6>Notes on the “KYC Process”</h6>
                        <ul>
                            <li>When the KYC process is unsuccessful then the reason is documented, and a support ticket is created in the system. The ticket number along with an explanation is communicated back to the user.</li>
                            <li>Once all proper documents are in our possession then the account gets approved.</li>
                        </ul>

                        <h6>“Other AML measures”</h6>
                        <ul>
                            <li>If a user has not passed full KYC, then they cannot make additional deposits or withdrawals of any amount.</li>
                            <li>If a user has passed the KYC process successfully then:</li>
                            <ul>
                                <li>There is a deposit limit per transaction (max EUR 2,000)</li>
                                <li>Prior to any withdrawal there is a detailed algorithmic and manual check on the activity and balance of the user to see if the amount withdrawn is a result of proper activity in the platform.</li>
                                <li>Under no circumstances may a user transfer funds directly to another user.</li>
                            </ul>
                        </ul>

            </div>
            <div className="card-footer">
                <button className="btn btn-block w-100 btn-lg my-2 rounded-0 btn-warning" onClick={onHide}>GOT IT</button>
            </div>
        </div>
            </Modal.Body >
        </Modal >
    );
};
